import $ from 'jquery'
import * as project from './functions'
import { renderMap } from './components/renderMap'
import './polyfill'

window.onload = () => {
  project.setupSlideshow('.section__slideshow-list', 'fullwidth')
  project.setupSlideshow('.section--higlights .container', 'cards')
  project.lazyLoad()
  project.smoothScroll()
  project.menuOverlay()
  project.setupModalVideo()
  project.childMenu()
  project.selectNumbers()
  project.setupServiceAccordion()
  project.newsAnimation()
  $('#loader').fadeOut(800)
}



// WEBPACK FOOTER //
// ./src/js/main.js